const DEFAULT_FETCH_TIMEOUT_MS = 8000;

export async function fetchWithTimeout(
    input: RequestInfo | URL,
    init: RequestInit = {},
    timeoutMs: number = DEFAULT_FETCH_TIMEOUT_MS
): Promise<Response> {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

    if (init.signal) {
        init.signal.addEventListener('abort', () => controller.abort(), { once: true });
    }

    try {
        return await fetch(input, { ...init, signal: controller.signal });
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') {
            throw new Error(`Fetch timed out after ${timeoutMs}ms: ${String(input)}`);
        }
        throw error;
    } finally {
        clearTimeout(timeoutId);
    }
}
